import SystemNotificationGenerator from 'scripts/domain/contracts/system_notification_generator';

export default function() {
  let notifications = new Map();

  SystemNotificationGenerator.newNotification = (notificationId, { title, body, icon, tag }) => {
    var options = {
      body,
      icon,
      tag,
    };
    let notification = new Notification(title, options);
    notifications.set(notificationId, notification);
    return notification;
  };

  SystemNotificationGenerator.canGenerateNotifications = () => {
    return 'Notification' in window && Notification.permission === 'granted';
  };

  SystemNotificationGenerator.closeNotification = id => {
    var notification = notifications.get(id);
    if (notification) {
      notification.close();
      clearTimeout(notification.timeoutId);
      notifications.delete(id);
    }
  };
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_system_notification_generator.js